export const detectWKWebView = () => {
  const userAgent = window.navigator.userAgent || "";
  const isIOSWebKit = /WebKit/.test(userAgent) && !/Safari/.test(userAgent);
  const lacksSharedWorker = !('sharedWorker' in window);

  return isIOSWebKit && lacksSharedWorker;
};

export const uuid = () => {
  if (crypto.randomUUID) return crypto.randomUUID();
  // crypto.randomUUID is only exposed in a secure context (HTTPS, or
  // http://localhost). In a non-secure context (e.g. plain HTTP on a custom
  // hostname) fall back to a valid RFC 4122 v4 UUID, so consumers relying on a
  // well-formed id (e.g. the poll vote endpoint's 15-char minimum userId) keep
  // working. crypto.getRandomValues is NOT gated behind a secure context, so
  // it's available here and gives a proper CSPRNG source unlike Math.random().
  const bytes = crypto.getRandomValues(new Uint8Array(16));
  bytes[6] = (bytes[6] & 0x0f) | 0x40; // version 4
  bytes[8] = (bytes[8] & 0x3f) | 0x80; // variant 10xx
  const hex = [...bytes].map((b) => b.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
};
